{
  "familyId": "GET-MACHT",
  "questions": [
    {
      "id": "GET-MACHT-001",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Wat betekent $2^3$?",
      "context": null,
      "options": ["2 × 2 × 2", "2 + 2 + 2", "2 × 3", "3 × 3"],
      "correctAnswer": 0,
      "conceptId": "power_notation_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Machtsverheffing",
            "content": "$a^n$ = a × a × a ... (n keer). Het grondtal (a) wordt n keer met zichzelf vermenigvuldigd. Voorbeeld: $2^3$ = 2 × 2 × 2 = 8."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 2 × 2 × 2. De macht $2^3$ betekent: het grondtal 2 wordt 3 keer met zichzelf vermenigvuldigd. De exponent (3) zegt hoe vaak. Dus $2^3$ = 2 × 2 × 2 = 8.",
        "distractorExplanations": {
          "0": "Goed! $2^3$ = 2 × 2 × 2 = 8. De exponent 3 zegt hoe vaak je het grondtal vermenigvuldigt.",
          "1": "2 + 2 + 2 = 6 is fout. Dat is optellen, niet machtsverheffing. $2^3$ betekent 2 keer zichzelf vermenigvuldigen (3 keer): 2 × 2 × 2 = 8.",
          "2": "2 × 3 = 6 is fout. Je hebt het grondtal en de exponent vermenigvuldigd. Maar $2^3$ betekent: 2 wordt 3 keer met zichzelf vermenigvuldigd: 2 × 2 × 2 = 8.",
          "3": "3 × 3 = 9 is fout. Je hebt de exponent met zichzelf vermenigvuldigd. Maar het grondtal is 2: $2^3$ = 2 × 2 × 2 = 8."
        }
      }
    },
    {
      "id": "GET-MACHT-002",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $3^2$ =",
      "context": null,
      "options": ["9", "6", "8", "5"],
      "correctAnswer": 0,
      "conceptId": "power_square_basic",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kwadraat berekenen",
            "content": "$3^2$ = 3 × 3 = 9. De exponent 2 zegt dat je het grondtal twee keer met zichzelf vermenigvuldigt."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 9. $3^2$ = 3 × 3 = 9. De exponent 2 zegt dat je het grondtal 3 twee keer met zichzelf vermenigvuldigt.",
        "distractorExplanations": {
          "0": "Goed! $3^2$ = 3 × 3 = 9.",
          "1": "6 is fout. Je hebt 3 × 2 = 6 of 3 + 3 = 6 berekend. Maar $3^2$ betekent 3 × 3 = 9, niet 3 × 2.",
          "2": "8 is fout. Je hebt misschien $2^3$ = 8 berekend (grondtal en exponent omgedraaid). Maar $3^2$ = 3 × 3 = 9.",
          "3": "5 is fout. Je hebt misschien 3 + 2 = 5 berekend. Maar $3^2$ betekent vermenigvuldigen: 3 × 3 = 9."
        }
      }
    },
    {
      "id": "GET-MACHT-003",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $4^2$ =",
      "context": null,
      "options": ["16", "8", "6", "12"],
      "correctAnswer": 0,
      "conceptId": "power_square_four",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kwadraat berekenen",
            "content": "$4^2$ = 4 × 4 = 16. De exponent 2 zegt dat je het grondtal twee keer met zichzelf vermenigvuldigt."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 16. $4^2$ = 4 × 4 = 16. De exponent 2 zegt dat je het grondtal 4 twee keer met zichzelf vermenigvuldigt.",
        "distractorExplanations": {
          "0": "Goed! $4^2$ = 4 × 4 = 16.",
          "1": "8 is fout. Je hebt 4 × 2 = 8 berekend. Maar $4^2$ betekent 4 × 4 = 16, niet 4 × 2.",
          "2": "6 is fout. Je hebt misschien 4 + 2 = 6 berekend. Maar $4^2$ betekent vermenigvuldigen: 4 × 4 = 16.",
          "3": "12 is fout. Je hebt misschien 4 × 3 = 12 berekend. Maar $4^2$ = 4 × 4 = 16."
        }
      }
    },
    {
      "id": "GET-MACHT-004",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $5^3$ =",
      "context": null,
      "options": ["125", "15", "25", "75"],
      "correctAnswer": 0,
      "conceptId": "power_cube_five",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Derde macht berekenen",
            "content": "$5^3$ = 5 × 5 × 5 = 125. Stap 1: 5 × 5 = 25. Stap 2: 25 × 5 = 125."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 125. $5^3$ = 5 × 5 × 5 = 125. Stap 1: 5 × 5 = 25. Stap 2: 25 × 5 = 125.",
        "distractorExplanations": {
          "0": "Goed! $5^3$ = 5 × 5 × 5 = 125. Stap 1: 5 × 5 = 25. Stap 2: 25 × 5 = 125.",
          "1": "15 is fout. Je hebt 5 × 3 = 15 berekend. Maar $5^3$ betekent 5 × 5 × 5 = 125, niet 5 × 3.",
          "2": "25 is fout. Je hebt $5^2$ = 5 × 5 = 25 berekend (exponent 2 in plaats van 3). $5^3$ = 5 × 5 × 5 = 125.",
          "3": "75 is fout. Je hebt misschien 25 × 3 = 75 berekend. Maar $5^3$ = 5 × 5 × 5 = 125. Stap 1: 5 × 5 = 25. Stap 2: 25 × 5 = 125."
        }
      }
    },
    {
      "id": "GET-MACHT-005",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Bereken: $10^3$ =",
      "context": null,
      "options": ["1000", "30", "100", "300"],
      "correctAnswer": 0,
      "conceptId": "power_ten_cube",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Machten van 10",
            "content": "$10^3$ = 10 × 10 × 10 = 1000. Regel: $10^n$ = 1 gevolgd door n nullen. Dus $10^3$ = 1000 (3 nullen)."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 1000. $10^3$ = 10 × 10 × 10 = 1000. Regel: $10^n$ = 1 gevolgd door n nullen. Dus $10^3$ = 1000 (3 nullen).",
        "distractorExplanations": {
          "0": "Goed! $10^3$ = 10 × 10 × 10 = 1000. Of: $10^3$ = 1 gevolgd door 3 nullen = 1000.",
          "1": "30 is fout. Je hebt 10 × 3 = 30 berekend. Maar $10^3$ = 10 × 10 × 10 = 1000.",
          "2": "100 is fout. Je hebt $10^2$ = 10 × 10 = 100 berekend (exponent 2 in plaats van 3). $10^3$ = 10 × 10 × 10 = 1000.",
          "3": "300 is fout. Je hebt misschien 100 × 3 = 300 berekend. $10^3$ = 10 × 10 × 10 = 1000. Of: 1 gevolgd door 3 nullen = 1000."
        }
      }
    },
    {
      "id": "GET-MACHT-006",
      "familyId": "GET-MACHT",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_basis",
      "questionType": "multiple_choice",
      "question": "Welke is groter: $2^4$ of $4^2$?",
      "context": null,
      "options": ["ze zijn even groot", "$2^4$", "$4^2$", "dat kun je niet zeggen"],
      "correctAnswer": 0,
      "conceptId": "power_compare",
      "variantIndex": 6,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Machten vergelijken",
            "content": "Bereken beide: $2^4$ = 2 × 2 × 2 × 2 = 16. $4^2$ = 4 × 4 = 16. Beide zijn 16, dus ze zijn even groot."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 'ze zijn even groot'. Bereken beide: $2^4$ = 2 × 2 × 2 × 2 = 16. $4^2$ = 4 × 4 = 16. Beide zijn 16, dus ze zijn even groot.",
        "distractorExplanations": {
          "0": "Goed! $2^4$ = 2 × 2 × 2 × 2 = 16 en $4^2$ = 4 × 4 = 16. Ze zijn allebei 16, dus even groot.",
          "1": "$2^4$ is fout. $2^4$ = 2 × 2 × 2 × 2 = 16 en $4^2$ = 4 × 4 = 16. Ze zijn allebei 16, dus even groot.",
          "2": "$4^2$ is fout. $4^2$ = 4 × 4 = 16 en $2^4$ = 2 × 2 × 2 × 2 = 16. Ze zijn allebei 16, dus even groot.",
          "3": "Je kunt het wél zeggen. Bereken beide: $2^4$ = 16 en $4^2$ = 16. Ze zijn even groot."
        }
      }
    }
  ]
}
